// Imported by relative path from `shared-sentry.client.config.ts`, so keep this module free of path aliases.

const MAX_HELD_SENTRY_LOGS = 50;

type SentryLogSender = () => void;

let isHoldingSentryLogs = false;
let heldSentryLogs: SentryLogSender[] = [];

export function holdSentryLogs(): void {
    isHoldingSentryLogs = true;
}

export function sendOrHoldSentryLog(sendLog: SentryLogSender): void {
    if (!isHoldingSentryLogs) {
        sendLog();
        return;
    }

    heldSentryLogs.push(sendLog);

    if (heldSentryLogs.length > MAX_HELD_SENTRY_LOGS) {
        heldSentryLogs.shift();
    }
}

export function releaseHeldSentryLogs(): void {
    const logsToSend = heldSentryLogs;

    isHoldingSentryLogs = false;
    heldSentryLogs = [];
    logsToSend.forEach(sendLog => sendLog());
}
